<template>
  <div class="content">
    <div style="display: none!important;">
      <electron-vue-printer ref="electronVuePrinter" :show="true" :options="options" :rotateType="rotateType"
        :silent="true">
      </electron-vue-printer>
    </div>
    {{print}}
    <div id="my-node">
      <div class="text-center" v-if="printer.file_name!=null"><img style="width: 100px"
          :src="axios.defaults.baseURL+'/api/v1/uploads/'+printer.file_name"></div>
      <h5>
        <div class="text-center" v-if="print_type != ''"><b>{{ print_type }}</b></div>
        <div class="text-center" v-if="datas.sklad">
          <b>{{ datas.sklad.name }}</b>
        </div>
      </h5>
      <h5 class="text-center" v-if="mysklad != null">
        <b>{{
          $t("Манзил") +
          ": " +
          mysklad.address}}</b>
        <br>
        <b>
          {{
          "Телефон: " +
          mysklad.phone_number}}
        </b>
      </h5>
      <h5 style="border-bottom: 2px double;">
        <div class="row">
          <div class="col-md-12">
            № {{ datas.daily_number }}
          </div>
          <div class="col-md-2" v-if="datas.kontragent">
            Клиент:
          </div>
          <div class="col-md-10 text-right pr-4" v-if="datas.kontragent">
            {{ datas.kontragent.name }}
          </div>
          <div class="col-md-2" v-if="kontragent!=null">
            {{$t('Манзил')}}:
          </div>
          <div class="col-md-10 text-right pr-4" v-if="kontragent!=null">
                        <p class="m-0"><b>{{ kontragent.address}}</b></p>
          </div>
          <div class="col-md-2" v-if="datas.kontragent">
            Телефон:
          </div>
          <div class="col-md-10 text-right pr-4" v-if="datas.kontragent">
            {{ datas.kontragent.phone_number }}
          </div>
          <div class="col-md-2" v-if="datas.created_at">
            {{ $t("Сана") }}:
          </div>
          <div class="col-md-10 text-right pr-4" v-if="datas.created_at">
            {{ Datetime() }}
          </div>
          <div class="col-md-2" v-if="datas.user">
            {{ $t("Ходим") }}
          </div>
          <div class="col-md-10 text-right pr-4" v-if="datas.user">
            {{ datas.user.first_name }}
          </div>
        </div>
      </h5>
      <h5 class="col-md-10 text-right pr-4" v-if="datas.kontragent && qarz != 0">
        {{ $t("Бошланғич сумма") }}: {{ boshsom|numFormatuniversal }}
      </h5>
      <h5 style="text-align: center;" v-if="datas.kontragent && qarz_dollar != 0">
        {{ $t("Бошланғич сумма") }} валюта: {{ boshdollar|numFormatuniversal }}
      </h5>
      <ul v-for="(item, index) in datas.rasxod_table" :key="index">
        <li>
          {{ index + 1 }}. <span v-if="item.product">{{
            item.product.extra_name || item.product.name
            }}</span>
        </li>
        <li style="text-align: right;">
          {{ item.count }} * {{ item.price|numFormatuniversal }} = {{ item.summa|numFormatuniversal }}
        </li>
      </ul>
      <ul v-if="datas.summa > 0">
        <li>
          <b>{{ $t("Жами сумма") }}:</b>
          <b style="float: right;">{{ datas.summa|numFormatuniversal }}</b>
        </li>
      </ul>
      <ul v-if="datas.skidka_summa > 0">
        <li>
          <b>{{ $t("Скидка") }}:</b><b style="float: right;">{{ datas.skidka_summa|numFormatuniversal }}</b>
        </li>
      </ul>
      <ul v-if="datas.dollar_summa > 0">
        <li>
          <b>{{ $t("Нахд") }} валюта:</b><b style="float: right;">{{ datas.dollar_summa|numFormatuniversal }}</b>
        </li>
      </ul>
      <ul v-if="datas.cash_summa > 0">
        <li>
          <b>{{ $t("Нахд") }}:</b><b style="float: right;">{{ datas.cash_summa|numFormatuniversal }}</b>
        </li>
      </ul>
      <ul v-if="datas.plastic_summa > 0">
        <li>
          <b>{{ $t("Пластик") }}:</b><b style="float: right;">{{ datas.plastic_summa|numFormatuniversal }}</b>
        </li>
      </ul>
      <ul>
        <li>
          <b>{{ $t("Тўлов") }}:</b><b style="float: right;">{{
            real_summa|numFormatuniversal
            }}</b>
        </li>
      </ul>
      <ul v-if="datas.refund_money > 0">
        <li>
          <b>{{ $t("Қайтим") }} сўм:</b><b style="float: right;">{{ datas.refund_money|numFormatuniversal }}</b>
        </li>
      </ul>
      <ul v-if="datas.refund_money_dollar > 0">
        <li>
          <b>{{ $t("Қайтим") }} валюта:</b><b style="float: right;">{{ datas.refund_money_dollar|numFormatuniversal
            }}</b>
        </li>
      </ul>
      <h5 style="text-align: center;" v-if="datas.kontragent && qarz != 0">
        {{ $t("Қолдиқ сумма") }}: {{ qarz|numFormatuniversal }}
      </h5>
      <h5 style="text-align: center;" v-if="datas.kontragent && qarz_dollar != 0">
        {{ $t("Қолдиқ сумма") }} валюта: {{ qarz_dollar|numFormatuniversal }}
      </h5>
      <span v-if="printer.qrcode">
        <qr-code v-if="printer.qrcode!=''" style="margin: 0 80px!important;width: 130px;"
          :text="printer.qrcode"></qr-code>
      </span>
      <h5 style="text-align: center;" v-if="mysklad != null">{{ mysklad.check_word }}</h5>
    </div>
  </div>
</template>
<script>
  import $ from "jquery";
  import html2canvas from "html2canvas";
  import VueQRCodeComponent from 'vue-qr'
  import * as htmlToImage from "html-to-image";
  import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
  import electronVuePrinter from "electron-vue-printer";
  import { setTimeout } from "timers";
  export default {
    name: "Printchek",
    components: {
      electronVuePrinter, htmlToImage, html2canvas,
      qrCode: VueQRCodeComponent
    },
    data() {
      return {
        print: 'false',
        axiosRess: { data: false },
        print_type: '',
        printer: '',
        datas: [],
        mysklad: null,
        rotateType: 0,
        options: {
          // offsetX: 0,
          // offsetY: 0,
          pageSize: { width: 78, height: 2970 }, // mm birligida
          // imageWidth: 290, // 80mm printer uchun kenglik
          // imageHeight: 300
        },
                kontragent: null,
        qarz: 0,
        qarz_dollar: 0,
        imgURL: null,
        axiosRes: {
          qarzdorlik: false,
          sklad: false,
          printName: false
        }
      };
    },
    async updated() {
      if (this.print == 'print') {
        this.$refs.electronVuePrinter.deviceNamePrint = this.printer.check_printer_name;
        await this.$refs.electronVuePrinter.print(this.dataUrl);
      }
    },
    mounted() {
      // this.options.imageHeight=document.getElementById("my-node").scrollHeight;
      setTimeout(() => {
        this.updateImageHeight(); // DOM yuklanganda o‘lchamni olish
      }, 1000);
    },
    created: function () {
      this.Data();
      this.GetPrinterName();
      if (localStorage.getItem("print_type")) {
        this.print_type = localStorage.getItem("print_type");
      }
    },
    methods: {
       GetKontragent(id) {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/kontragent/id/" + id
        }).then(function (response) {
          self.kontragent = response.data;
        });
      },
      updateImageHeight() {
        this.$nextTick(() => {
          const element = document.getElementById("my-node");
          if (element) {
            console.log(element.scrollHeight);
            if (element.scrollHeight > 1000) {
              // this.options.imageHeight = element.scrollHeight-(element.scrollHeight*0.14);
              // this.options.imageHeight = element.scrollHeight-800;
              // console.log(this.options.imageHeight);
            } else {
              // this.options.imageHeight = element.scrollHeight;
            }
            this.Printer();
          } else {
          }
        });
      },
      GetPrinterName() {
        let self = this;
        axios({
          method: "post",
          url: "api/v1/sklad-settings",
          data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
        }).then(function (response) {
          if (response.data.data != null) {
            self.axiosRes.printName = true
            self.printer = JSON.parse(response.data.data);
          }
        });
      },
      Starprinting(data) {
        if (data == true && this.imgURL) {
          localStorage.removeItem("print_type");
          window.close();
        }
        // }else{
        //   this.Starprinting(true) 
        // }
      },
      Data() {
        let self = this;
        axios
          .get("api/v1/rasxod/id/" + self.$route.params.id)
          .then(function (response) {
            self.datas = response.data;
            self.axiosRess.data = true;
            self.Mysklad();
            if (response.data.kontragent_id > 0) {
            self.GetKontragent(response.data.kontragent_id);
            }
            self.Qarzdorlik();
          });
      },
      async Printer() {
        let self = this;
        const element = document.getElementById("my-node");
        console.log("Offset Height:", element.offsetHeight);
        console.log("Scroll Height:", element.scrollHeight);

        const elementHeight = element.scrollHeight;
        const paperHeight = Math.max(500, elementHeight); // Minimum 500px yoki real uzunlik
        if (self.axiosRes.qarzdorlik && self.axiosRes.sklad && self.axiosRes.printName) {
          // self.options.scrollHeight=document.getElementById("my-node").scrollHeight-200;
          await htmlToImage
            .toSvg(document.getElementById("my-node"), {
              // quality: 1, 
              // pixelRatio: 2,
            })
            .then(function (dataUrl) {
              //               let img = new Image();
              //     img.src = dataUrl;
              //     document.body.appendChild(img);
              //               // const link = document.createElement("a");
              //     // link.href = dataUrl; // `canvas.toDataURL()` emas, balki `dataUrl`
              //     // link.download = "screenshot.png";
              //     // link.click();
              self.dataUrl = dataUrl;
              self.print = 'print';
              self.imgURL = dataUrl;
              setTimeout(() => {
                self.data_await()
              }, 3000);
            })
          //             .catch(function (error) {
          //             });
        } else {
          setTimeout(() => {
            self.Printer()
          }, 1000);
        }
      },
      Qarzdorlik() {
        let self = this;
        self.qarz = 0;
        self.qarz_dollar = 0;
        axios({
          method: "post",
          url: "api/v1/kontragent/total",
          data: {
            kontragent_id: self.datas.kontragent_id,
            sklad_id: self.datas.sklad_id,
            datetime: self.datas.created_at
          }
        }).then(function (response) {
          response.data.forEach(function (key, value) {
            if (key.pay_type_id == 3) {
              self.qarz_dollar = key.total;
            } else {
              self.qarz += key.total;
            }
          });
          self.axiosRes.qarzdorlik = true;
        });
      },
      Mysklad() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/sklads/id/" + self.datas.sklad_id
        }).then(function (response) {
          self.axiosRes.sklad = true;
          self.mysklad = response.data;
        });
      },
      Datetime() {
        var d = new Date();
        var dt = d.getDate();
        var month = d.getMonth() + 1;
        var hour = d.getHours();
        var minut = d.getMinutes();
        var sekund = d.getSeconds();
        if (month < 10) {
          month = "0" + month;
        }
        if (dt < 10) {
          dt = "0" + dt;
        }
        if (hour < 10) {
          hour = "0" + hour;
        }
        if (minut < 10) {
          minut = "0" + minut;
        }
        if (sekund < 10) {
          sekund = "0" + sekund;
        }

        return dt + "." + month + "." + d.getFullYear() + " " + hour + ":" + minut + ":" + sekund;
      },
      data_await() {
        let self = this;
        if (self.imgURL && self.axiosRes.qarzdorlik && self.axiosRes.sklad && self.axiosRes.printName) {
          self.Starprinting(true)
        } else {
          self.data_await()
        }

      }
    },
    watch: {
      "$store.state.changed": function () {
        if (this.$store.state.changed != null) {
          this.Ostatka(this.$store.state.selected_index);
          this.$store.state.changed = null;
        }
      }
    },
    computed: {
      boshsom() {
        var data = 0;
        if (this.datas.pay_type_id != 3) {
          data = this.qarz - (this.datas.summa - this.datas.skidka_summa - this.datas.cash_summa - this.datas.plastic_summa - this.datas.shot_summa - this.datas.dollar_summa * this.datas.dollar_rate + this.datas.refund_money + this.datas.refund_money_dollar * this.datas.dollar_rate);
        } else {
          data = this.qarz;
        }
        return data;
      },
      boshdollar() {
        var data = 0;
        if (this.datas.pay_type_id == 3) {
          data = this.qarz_dollar - (this.datas.summa - this.datas.skidka_summa - this.datas.cash_summa / this.datas.dollar_rate - this.datas.plastic_summa / this.datas.dollar_rate - this.datas.shot_summa / this.datas.dollar_rate - this.datas.dollar_summa + this.datas.refund_money / this.datas.dollar_rate + this.datas.refund_money_dollar);
        } else {
          data = this.qarz_dollar;
        }
        return data;
      },
      real_summa() {
        return this.datas.summa - this.datas.skidka_summa;
      },
    }
  };
</script>
<style scoped>
  #my-node div,
  #my-node li,
  #my-node b,
  #my-node h5 {
    /* font-size: 6pt !important; */
  }

  #my-node {
    /* Sahifa bo‘ylab kesilmasligi uchun */
    /* transform: scale(1); */
    height: auto !important;
    padding: 0 !important;
    width: 280px;
    /* 80mm printer uchun */
    max-height: none !important;
    overflow: visible !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    font-weight: bold;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  * {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  #my-node img {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  h5 {
    font-weight: bold;
    font-size: 13px;
    color: black;
  }

  ul {
    list-style: none;
    border-bottom: 3px solid #000;
    text-align: left;
    padding: 0;
    margin: 0;
    font-size: 12px;
    font-weight: bold;
    color: black;
  }

  ul>li {
    padding-right: 6px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }
</style>
